function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
import omit from 'object.omit';
import VCheckbox from '@cloud-sn/v-checkbox';
import { buildComponentName } from '../utils';
import Mixin from './mixin';
var __vue_script__ = {
  name: buildComponentName('Radio'),
  $_veeValidate: {
    rejectsFalse: true,
    value: function value() {
      return this.$refs.radioRef.getValue();
    }
  },
  components: {
    VCheckbox: VCheckbox
  },
  mixins: [Mixin],
  inheritAttrs: false,
  model: {
    prop: 'checked'
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-radio'
    },
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bindProps: function bindProps() {
      var $props = this.$props,
          isChildren = this.isChildren,
          rootName = this.rootName,
          rootValue = this.rootValue,
          rootDisabled = this.rootDisabled;
      var p = omit($props, 'label');
      p.type = 'radio';

      if (isChildren) {
        p.name = p.name || rootName;
        p.checked = p.value === rootValue;
        p.disabled = p.disabled !== null ? !!p.disabled : rootDisabled;
      }

      return p;
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          isChildren = this.isChildren,
          onInput = this.onInput,
          onChange = this.onChange,
          onGroupChange = this.onGroupChange;

      var p = _objectSpread({}, $listeners, {
        input: onInput,
        change: onChange
      });

      if (isChildren) {
        p.change = function (e) {
          onGroupChange(e.target.value);
        };
      }

      return p;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          _this$bindProps = this.bindProps,
          checked = _this$bindProps.checked,
          disabled = _this$bindProps.disabled;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_ref, "".concat(prefixCls, "-wrapper-checked"), checked), _defineProperty(_ref, "".concat(prefixCls, "-wrapper-disabled"), disabled), _ref;
    }
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val);
    },
    onChange: function onChange(e) {
      this.$emit('change', e);
    },
    focus: function focus() {
      var radioRef = this.$refs.radioRef;

      if (radioRef) {
        radioRef.focus();
      }
    },
    blur: function blur() {
      var radioRef = this.$refs.radioRef;

      if (radioRef) {
        radioRef.blur();
      }
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('label', {
    class: _vm.classes
  }, [_c('v-checkbox', _vm._g(_vm._b({
    ref: "radioRef"
  }, 'v-checkbox', [_vm.$attrs, _vm.bindProps], false), _vm.bindListeners)), _vm.label || _vm.$slots.default ? _c('span', [_vm._t("default", [_vm._v(_vm._s(_vm.label))])], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "radio.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;